import { useTranslation } from 'react-i18next'

import {
  StyledContentContainer,
  StyledTitle,
  StyledSubtitle,
} from '../../UpdatePassword/components'

export const AccountSuccess = () => {
  const { t } = useTranslation()

  return (
    <StyledContentContainer>
      <StyledTitle className="steps-title">{t('verifyUser.success.title')}</StyledTitle>
      <StyledSubtitle className="confirm-pass-input">{t('verifyUser.success.body')}</StyledSubtitle>
    </StyledContentContainer>
  )
}
